/**
 * Page Referrer Handler
 * 
 * Stores the referrer URL when navigating to a product page.
 * Redirects back to this referrer URL when using the browser's back button.
 * This ensures proper redirection after user switches variants on product page,
 * whether they came from a collection, search results, homepage or any other page.
 */

if (document.referrer && 
    document.referrer.startsWith(window.location.origin) && // Only store internal referrers
    window.location.pathname.includes("/products/")) {
  sessionStorage.setItem("lastPageUrl", document.referrer);
}

window.addEventListener("popstate", function () {
  const lastPageUrl = sessionStorage.getItem("lastPageUrl");

  if (lastPageUrl) {
    window.location.href = lastPageUrl;
  }
});